import { Currency, Segment, SegmentEntity, WithBaseEntitySchema } from '@40seas/models';
import { AtradiusCoverStatus } from './atradius-cover.status';
import { z } from 'zod';
import { EnumSchema, FromSchema } from '@40seas/entities/common';

export const AtradiusCoverSchema = WithBaseEntitySchema(
    z.object({
        buyer: z.string(),
        atradiusCompany: z.string(),
        coverId: z.string(),
        status: EnumSchema(AtradiusCoverStatus),
        coverAmount: z.number().optional(),
        decisionComment: z.string().optional(),
        decision: z
            .object({
                decisionAmountInPolicyCurrency: z.number(),
                decisionConditions: z.array(
                    z.object({
                        conditionDescription: z.string(),
                        conditionCategoryDescription: z.string(),
                    }),
                ),
            })
            .optional(),
        coverCurrency: z.string().optional(),
        decisionDate: z.date().optional(),
        startDate: z.date().optional(),
        lastUpdated: z.date().optional(),
    }),
).strict();

export class AtradiusCoverDecision {
    decisionAmountInPolicyCurrency: number;
    decisionConditions: AtradiusCoverDecisionCondition[];
}

export class AtradiusCoverDecisionCondition {
    conditionDescription: string;
    conditionCategoryDescription: string;
}

export class AtradiusCover extends FromSchema(AtradiusCoverSchema) implements SegmentEntity {
    id: string;
    buyer: string;
    atradiusCompany: string;
    coverId: string;
    status: AtradiusCoverStatus;
    coverAmount?: number;
    decisionComment?: string;
    decision?: AtradiusCoverDecision;
    coverCurrency?: Currency;
    decisionDate?: Date;
    startDate?: Date;
    lastUpdated?: Date;
    createdAt?: Date;
    updatedAt?: Date;
    segments?: Segment[];
    tenantId: string;
    buyerRating?: number;
    buyerClass?: number;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
    seller: string;
}
